<app-content contentTitle="{{ 'translate_evaluations_list' | translate }}">
    @if (canShowAddButton) {
        <button
            tools
            (click)="showDetailDialog(undefined, $event, { mode: 'default' })"
            class="btn btn-sm btn-outline-white flex flex-row items-center gap-2"
        >
            <i class="fa-light fa-plus"></i>
            <span>{{ 'translate_add_new' | translate }}</span>
        </button>
    }

    <app-list-loading content [items]="instances">
        <div
            class="overflow-hidden rounded-2xl border border-slate-200 bg-white"
        >
            <div class="table-responsive">
                <table>
                    <thead>
                        <tr>
                            <th>{{ 'translate_name' | translate }}</th>
                            <th>{{ 'translate_creation_time' | translate }}</th>
                            <th>{{ 'translate_score' | translate }}</th>
                            <th>
                                {{
                                    'translate_evaluation_score_band'
                                        | translate
                                }}
                            </th>
                            @for (
                                label of matrixScoreColumnLabels;
                                track label
                            ) {
                                <th>
                                    {{ label }}
                                </th>
                            }
                            <th class="w-0"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (instance of instances; track instance) {
                            <tr>
                                <td>{{ instance.name }}</td>
                                <td>
                                    {{
                                        instance.creationTime
                                            | date: 'yyyy-MM-dd'
                                    }}
                                </td>
                                <td>%{{ instance.score * 100 | round: 0 }}</td>
                                <td>
                                    @if (getScoreBand(instance); as band) {
                                        <span
                                            class="text-sm font-medium"
                                            [style.color]="band.color"
                                        >
                                            {{ band.name }}
                                        </span>
                                    } @else {
                                        <span class="text-slate-400">—</span>
                                    }
                                </td>
                                @for (
                                    label of matrixScoreColumnLabels;
                                    track label;
                                    let columnIndex = $index
                                ) {
                                    <td>
                                        @if (
                                            getMatrixRawScore(
                                                instance,
                                                columnIndex
                                            ) !== null
                                        ) {
                                            %{{
                                                getMatrixRawScore(
                                                    instance,
                                                    columnIndex
                                                )! * 100 | round: 0
                                            }}
                                        } @else {
                                            <span class="text-slate-400"
                                                >—</span
                                            >
                                        }
                                    </td>
                                }
                                <td>
                                    <app-dropdown>
                                        <button
                                            class="action-icon action-icon-view"
                                            [disabled]="
                                                currentlyProcessing.has(
                                                    instance.id
                                                )
                                            "
                                            [appTooltip]="
                                                'translate_view' | translate
                                            "
                                            (click)="
                                                showDetailDialog(
                                                    instance.id,
                                                    $event,
                                                    {
                                                        mode: 'view',
                                                    }
                                                )
                                            "
                                        >
                                            <i class="fa-light fa-eye"></i>
                                        </button>
                                        @if (canManageInstances) {
                                            <button
                                                class="action-icon action-icon-edit"
                                                [disabled]="
                                                    currentlyProcessing.has(
                                                        instance.id
                                                    )
                                                "
                                                [appTooltip]="
                                                    'translate_edit' | translate
                                                "
                                                (click)="
                                                    showDetailDialog(
                                                        instance.id,
                                                        $event,
                                                        {
                                                            mode: 'default',
                                                        }
                                                    )
                                                "
                                            >
                                                <i class="fa-light fa-edit"></i>
                                            </button>
                                        }
                                        @if (canManageInstances) {
                                            <app-delete-button
                                                [isDisabled]="
                                                    currentlyProcessing.has(
                                                        instance.id
                                                    )
                                                "
                                                (delete)="delete(instance)"
                                                [itemName]="instance.name"
                                                [appTooltip]="
                                                    'translate_delete'
                                                        | translate
                                                "
                                            ></app-delete-button>
                                        }
                                    </app-dropdown>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </app-list-loading>
</app-content>
